export default {
      id: "icon-other-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-other",
      toString: function () {
        return this.url;
      }
    }